import { Bot, Plus } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { Card, CardContent } from '@/shared/components/ui/card'
import type { Agent } from '../types/agent.types'
import { AgentCard } from './AgentCard'

interface AgentsGridProps {
  agents: Agent[]
  onViewAgent?: (agent: Agent) => void
  onAction?: (action: string, agent: Agent) => void
  onCreateAgent?: () => void
  searchQuery?: string
  statusFilter?: string
}

export function AgentsGrid({
  agents,
  onViewAgent,
  onAction,
  onCreateAgent,
  searchQuery,
  statusFilter,
}: AgentsGridProps) {
  if (agents.length === 0) {
    return (
      <Card>
        <CardContent className='pt-16 pb-16'>
          <div className='text-center'>
            <Bot className='w-16 h-16 mx-auto text-muted-foreground/50 mb-4' />
            <h3 className='text-lg font-medium mb-2'>No agents found</h3>
            <p className='text-muted-foreground mb-6'>
              {searchQuery || statusFilter !== 'all'
                ? 'Try adjusting your search criteria'
                : 'Create your first agent to get started'}
            </p>
            {!searchQuery && statusFilter === 'all' && (
              <Button onClick={onCreateAgent}>
                <Plus className='w-4 h-4 mr-2' />
                Create Agent
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
      {agents.map(agent => (
        <AgentCard
          key={agent.id}
          agent={agent}
          onView={onViewAgent}
          onAction={onAction}
        />
      ))}
    </div>
  )
}
